import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "px-4 pb-4 h-full w-full" }
const _hoisted_2 = { class: "flex flex-col items-center w-full h-full" }
const _hoisted_3 = {
  id: "chatArea",
  class: "h-full w-full overflow-y-auto flex flex-col gap-3 pt-4"
}
const _hoisted_4 = { class: "w-full h-auto mt-3" }
const _hoisted_5 = { class: "w-full h-auto flex flex-row items-center justify-center" }

import { IonPage, IonContent, IonIcon, toastController } from '@ionic/vue';
import { onMounted, onUpdated, ref, Ref } from 'vue';
import { send } from 'ionicons/icons';
import axios from 'axios'
import { Storage } from '@capacitor/storage'
import { Comment } from '@/interfaces/comment/Comment';
import { useCompany } from '@/store/company';
import { useUsers } from '@/store/users';
import { useSelectedProject } from '@/store/selectedProject';
import CommentDiv from '@/components/DetailPage/CommentPage/CommentDiv.vue'
import { alertController } from '@ionic/core'
import { useCurrentUser } from '@/store/currentUser'


export default /*#__PURE__*/_defineComponent({
  __name: 'CommentsPage',
  setup(__props) {

const selectedProjectStore = useSelectedProject()
const currentUserStore = useCurrentUser()

const companyStore = useCompany()
const searchValue: Ref<string> = ref("")
async function sendMessage() {
  if(searchValue.value === '') {
    return
  }
  try {
    const commentResponse: { _id: string } = (await axios.post(process.env.VUE_APP_PROJECT_API_BASE_URL + 'project/' + selectedProjectStore.project._id + '/comment' + '/?company=' + companyStore.activeCompany.id, {
      user: currentUserStore.currentUser.user.id,
      updated_by: currentUserStore.currentUser.user.id,
      content: searchValue.value,
    }, {
      headers: {
        Authorization: 'Bearer ' + (await Storage.get({ key: 'jwt' })).value
      },
    })).data.data

    const comment: Comment = { 
      _id: commentResponse._id, 
      content: searchValue.value, 
      created_at: new Date().toString(), 
      updated_at: new Date().toString(),
      user: currentUserStore.currentUser.user.id,
      project: selectedProjectStore.project._id
    }

    selectedProjectStore.project.comments.push(comment)
    scrollToBottom()
    searchValue.value = ""
  } catch (e: any) {
    const alert = await alertController.create({
      message: e.response.status + ': Konnte die Nachricht nicht senden',
      buttons: ['OK']
    })
    await alert.present()
    console.error(e)
  }
}

function scrollToBottom() {
  setTimeout(() => {
    const container = document.querySelector("#chatArea")!
    container.scrollTop = container.scrollHeight;
  })
}

onUpdated(() => {
  scrollToBottom()
})

onMounted(async() => {
  scrollToBottom()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedProjectStore).project.comments, (comment) => {
                  return (_openBlock(), _createBlock(CommentDiv, {
                    comment: comment,
                    key: comment._id
                  }, null, 8, ["comment"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (sendMessage()), ["enter"])),
                    enterkeyhint: "send",
                    class: "min-h-10 w-0 h-auto resize-none bg-zewotherm-lightgrey text-zewotherm-darkGrey placeholder-zewotherm-grey flex-grow font-bold rounded-lg p-2 mr-3 outline-none",
                    placeholder: "Kommentar"
                  }, null, 544), [
                    [_vModelText, searchValue.value]
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (sendMessage())),
                    type: "button",
                    style: _normalizeStyle('background-color: ' + _unref(companyStore).activeCompany.color),
                    class: "w-10 h-10 rounded-lg translate cursor-pointer flex justify-center items-center active:scale-90 duration-200"
                  }, [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(send),
                      class: "text-white w-2/5 h-2/5"
                    }, null, 8, ["icon"])
                  ], 4)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})